export enum SETTINGS_KEYS {
	NAME = 'name',
	EMAIL = 'email',
	PHONE = 'phone',
	ADDRESS = 'address',
	DESCRIPTION = 'description',
	REGISTRATION_CODE = 'registrationCode',
	LOGO_ID = 'logoId',
	FACEBOOK_URL = 'facebookUrl',
	INSTAGRAM_URL = 'instagramUrl',
	WHATSAPP_NUMBER = 'whatsappNumber',
	GOOGLE_MAP_ADDRESS_URL = 'googleMapAddressUrl',
	ENABLE_TAX_RATE = 'enableTaxRate',
	TAX_RATE = 'taxRate',
	TAX_INCLUDE_IN_PRICE = 'taxIncludeInPrice',
	ENABLE_EMAIL_NOTIFICATION = 'enableEmailNotification',
	ENABLE_ORDER_NOTIFICATION = 'enableOrderNotification',
	ENABLE_SHIPPING_NOTIFICATION = 'enableShippingNotification',
	WHATSAPP_NOTIFICATION = 'whatsappNotification',
}
